export interface SalesOrderFromPreviousIds {
  id: string;
  quantity: number;
}
